import { AddAlert } from '../../../components'
import apiPdca from '../../../helpers/apiPdca'

export const setIntegracaoUsuarioPdca = payload => ({
  type: 'SET_INTEGRACAO_USUARIO_PDCA',
  payload
})

export const setLoadingIntegracaoUsuarioPdca = payload => ({
  type: 'SET_LOADING_INTEGRACAO_USUARIO_PDCA',
  payload
})

export const setErroIntegracaoUsuarioPdca = payload => ({
  type: 'SET_ERRO_INTEGRACAO_USUARIO_PDCA',
  payload
})

export const cleanIntegracaoUsuarioPdca = () => ({
  type: 'CLEAN_INTEGRACAO_USUARIO_PDCA'
})

export const obterIntegracaoUsuarioPdca = nls => {
  return async dispatch => {
    dispatch(setLoadingIntegracaoUsuarioPdca(true))
    dispatch(setErroIntegracaoUsuarioPdca({}))

    try {
      const response = await apiPdca.get('/pdca/obterusuariosexternospdca')

      dispatch({
        type: 'SET_INTEGRACAO_USUARIO_PDCA_RESPONSE',
        payload: {
          usernametrello: response?.data?.usernametrello || '',
          useraccountidjira: response?.data?.useraccountidjira || ''
        }
      })
    } catch (error) {
      dispatch(setErroIntegracaoUsuarioPdca(error))
      dispatch(AddAlert('danger', nls.erroLeitura))
    } finally {
      dispatch(setLoadingIntegracaoUsuarioPdca(false))
    }
  }
}

export const gravarIntegracaoUsuarioPdca = (integracao, nls, onSuccess) => {
  return async dispatch => {
    dispatch(setLoadingIntegracaoUsuarioPdca(true))
    dispatch(setErroIntegracaoUsuarioPdca({}))

    try {
      await apiPdca.post('/pdca/gravarusuariosexternospdca', {
        usernametrello: integracao?.usernametrello || null,
        useraccountidjira: integracao?.useraccountidjira || null
      })

      dispatch(AddAlert('success', nls.sucessoSalvar))

      if (onSuccess) {
        onSuccess()
      }
    } catch (error) {
      dispatch(setErroIntegracaoUsuarioPdca(error))
      dispatch(AddAlert('danger', nls.erroSalvar))
    } finally {
      dispatch(setLoadingIntegracaoUsuarioPdca(false))
    }
  }
}